import { gql } from "@apollo/client"
import { MiniTeamProfileFragment } from "@pallet/features/RecruitingTeamType/MiniTeamProfile/fragments"

export const LikableTeamsFragment = gql`
    fragment LikableTeamsFragment on RecruitingTeamConnection {
        pageInfo {
            hasNextPage
            endCursor
        }
        edges {
            node {
                id
                ...MiniTeamProfileFragment
            }
        }
    }
    ${MiniTeamProfileFragment}
`
